/**
 * Bases de URL das APIs — ponto ÚNICO que decide entre same-origin e cross-origin.
 *
 * Por que same-origin: o Chrome aborta todas as requisições em voo quando qualquer interface de rede
 * do SO muda (`ERR_NETWORK_CHANGED`). Roteando pelo proxy (Vite em dev, nginx em produção), o browser
 * fala só com a própria origem e o servidor segura a conexão upstream — foi assim que a conversão de
 * carta, que falhava só na URL pública, passou a funcionar. De brinde, desaparece o preflight
 * `OPTIONS` de cada requisição.
 *
 * Verificado: a autenticação vai por header `Authorization`, nunca por cookie (`withCredentials` não
 * existe no projeto), e o proxy repassa o header — medi a mesma requisição pelos dois caminhos e o
 * resultado é byte-a-byte idêntico (200, 78.163 bytes).
 */

/** API principal. Proxiada porque `VITE_NEXATLAS_API_URL` é igual nos 5 `.env`. */
export const NEXATLAS_API_BASE = '/nexatlas-api'

/** API de dados aeronáuticos. Proxiada porque `VITE_AERODATA_API_BASEURL` é igual nos 5 `.env`. */
export const AERODATA_API_BASE = '/aerodata'

/** BFF do pilotapp (conversor de cartas). */
export const PILOTAPP_BFF_BASE = '/pilotapp-bff'

/**
 * BFF próprio: segue CROSS-ORIGIN fora do dev porque `VITE_BFF_URL` muda por ambiente
 * (`alpha.` / `beta.` / produção) e o `nginx.conf` é estático na imagem.
 * Proxiar exigiria templating com `envsubst` — fica para outra rodada.
 * Só o dev é same-origin (`/bff`, proxy do Vite), porque a página roda em https e o BFF local em http.
 */
export const BFF_BASE = import.meta.env.VITE_BFF_URL
